module.exports = __webpack_public_path__ + "img/2b31d2a.svg";